import { InitialStepForm } from '../../../schemas/initialStepSchema';
import { CreateOrUpdateProgramPayload } from '../../../types/program';

export const getInitialProgramPayload = (
  fields: InitialStepForm
): Partial<CreateOrUpdateProgramPayload> => {
  return {
    name: fields.name || '',
    typeIds: [fields.typeProgramId],
    instructorIds: fields.instructorIds?.filter((id): id is number => !!id),
    segmentId: Number(fields.segmentId),
    description: fields.description?.trim() ?? undefined,
  };
};
